export default function fFormConditions () {
    const oRevealSources = document.querySelector('.js-form-reveal');

    if (!oRevealSources) return;

    const oRevealTarget = document.getElementById(oRevealSources.getAttribute('data-form-reveal'));
    const aRevealInputs = oRevealTarget.querySelectorAll('input');

    oRevealSources.addEventListener('click', function (event) {
        if (event.target.matches('.js-form-reveal-source') || event.target.closest('.js-form-reveal-source')) {
            let oElement = event.target.parentNode.querySelector('input');

            if (oElement.checked) {
                oRevealTarget.style.display = 'block';

                // Set required attributes on newly shown inputs
                for (let a = 0; a < aRevealInputs.length; a += 1) {
                    aRevealInputs[a].setAttribute('required', true);
                }
            }
        } else {
            oRevealTarget.style.display = 'none';

            // Remove required attributes on reveal targets when deselecting source
            for (let b = 0; b < aRevealInputs.length; b += 1) {
                aRevealInputs[b].removeAttribute('required');
            }
        }
    }, false);
}
